/* eslint-disable */
import React, { useEffect, useState } from "react";
import {
	Card,
	Button,
	Typography,
	Row,
	Col,
	Modal,
	QRCode,
	Space,
	message,
} from "antd";
import "./index.css"; // 引入 CSS 文件
import {
	CloudSyncOutlined,
	RollbackOutlined,
	UsergroupAddOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../providers/CustomThemeProvider";
import { GetPayUrl, PollingPayStatus } from "../../api/Api";
// import logoall from "../../assets/logo-all.png";

const { Title, Paragraph } = Typography;

interface PlanProps {
	title: string;
	descList: any;
	buttonText: string;
	onButtonClick: () => void;
	currentType: boolean;
}

const PlanCard: React.FC<PlanProps> = ({
	title,
	descList,
	buttonText,
	onButtonClick,
	currentType,
}) => {
	return (
		<Card
			className="plan-card"
			bordered={false}
			style={{
				height: "65vh",
				width: "26vw",
				backgroundColor: currentType ? "rgb(35,35,56)" : "rgb(68,84,246)",
			}}
		>
			<div className="plan-card-content">
				<div className="plan-card-content-main">
					<Title level={3} className="plan-title">
						{title}
					</Title>
					<div className="plan-description">
						{descList?.map((item: any, index: number) => {
							return (
								<div className="plan-desc-block" key={index}>
									<CloudSyncOutlined style={{ marginRight: "20px" }} />
									<span className="plan-desc-block-text">{item}</span>
								</div>
							);
						})}
					</div>
				</div>
				<div className="plan-card-footer">
					<Button
						disabled={currentType}
						type="primary"
						className={`plan-button ${currentType ? "" : "plan-light"}`}
						onClick={onButtonClick}
					>
						{buttonText}
					</Button>
				</div>
			</div>
		</Card>
	);
};

const UpgradePlans: React.FC = () => {
	const navigate = useNavigate();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [codeUrl, setCodeUrl] = useState<string>("");
	const [orderId, setOrderId] = useState<any>("");
	const [isPolling, setIsPolling] = useState<boolean>(true);
	// const [orderStatus, setOrderStatus] = useState<string>("");

	const { isDarkMode, switchTheme } = useTheme();
	const handleUpgrade = (plan: string) => {
		console.log(`Upgrade to ${plan} plan`);
		getCodeUrl();
		setIsModalOpen(true);
	};

	const getCodeUrl = async () => {
		try {
			const res = (await GetPayUrl({ cents: 1000 })) as any;
			console.log("getCodeUrl", res);
			res?.codeUrl && setCodeUrl(res?.codeUrl);
			res?.orderId && setOrderId(res?.orderId);
		} catch (e) {}
	};

	const pollingStatus = async () => {
		if (!orderId) return;

		try {
			const res = (await PollingPayStatus({ id: orderId })) as any;
			if (res?.status == "SUCCESS") {
				setIsPolling(false);
				message.success("支付成功");
				setIsModalOpen(false);
			} else if (res?.status == "CLOSED") {
				setIsPolling(false);
				message.info("交易已取消");
				setIsModalOpen(false);
			}
		} catch (e) {}
	};

	useEffect(() => {
		if (isPolling) {
			const interval = setInterval(pollingStatus, 2000); // 每2秒钟请求一次
			return () => clearInterval(interval); // 清理定时器
		}
	}, [isPolling, codeUrl]);

	useEffect(() => {
		if (codeUrl) {
			setIsPolling(true);
		}
	}, [codeUrl]);

	const showModal = () => {
		setIsModalOpen(true);
	};

	const handleOk = () => {
		setIsModalOpen(false);
	};

	const handleCancel = () => {
		setIsModalOpen(false);
	};

	return (
		<>
			<Modal
				title="请扫码完成支付"
				open={isModalOpen}
				onOk={handleOk}
				onCancel={handleCancel}
				footer={null}
				width={300}
			>
				<Space direction="vertical" align="center">
					<QRCode value={codeUrl || "-"} />
				</Space>
			</Modal>

			<div className="upgrade-plans">
				<div className="upgrade-plans-header">
					<div className="header-logo">{/* <img src={logoall} /> */}</div>
					{/* <Button> */}
					<RollbackOutlined
						onClick={() => {
							navigate("/d5data");
						}}
						style={{ fontSize: 20, color: "white", cursor: "pointer" }}
					/>
					{/* </Button> */}
				</div>
				<div className="upgrade-plans-content">
					<div className="page-title">套餐升级</div>
					{/* <Row gutter={[24, 24]} justify="center">
          <Col xs={24} sm={12} md={8}> */}
					<div className="upgrade-plans-content-cards">
						<PlanCard
							key={"free"}
							title="免费版"
							descList={[
								"可以使用全部的data-gpt和DLP功能",
								"对DLP的任务数量和数据集大小具有有限的访问权限",
								"对data-gpt数据请求数量具有有限的访问权限",
							]}
							buttonText="当前版本"
							onButtonClick={() => handleUpgrade("Basic")}
							currentType={true}
						/>
						{/* </Col> */}
						{/* <Col xs={24} sm={12} md={8}> */}
						<PlanCard
							key={"pro"}
							title="专业版"
							descList={[
								"可以使用全部的data-gpt和DLP功能拥有更多会员免费额度",
								"更快的检索速度，更多的AI算力配额",
								"对data-gpt数据请求数量没有限制，可以异步接受大量数据（超出免费额度的部分将按token数量收费）",
								"对DLP的任务数量和数据集大小没有限制，超出免费额度的部分将按使用量收费",
								"DLP可按需设置自动清洗",
							]}
							buttonText="立即开启"
							onButtonClick={() => handleUpgrade("Pro")}
							currentType={false}
						/>
						{/* </Col>
        </Row> */}
					</div>
				</div>
				<div className="upgrade-plans-footer">
					<UsergroupAddOutlined style={{ fontSize: 20 }} />
					<div className="upgrade-plans-footer-text">
						用户协议用户协议用户协议用户协议
					</div>
				</div>
			</div>
		</>
	);
};

export default UpgradePlans;
